import React, { useState } from "react";
import "../../../css/CRUDModal.css";
import ButtonTriangle from "../../../assets/Icons/Button Triangle.png";
import LeftCircle from "../../../assets/Icons/Left circle B.png";
import RightCircle from "../../../assets/Icons/Right circle A.png";
import FilterIcon from "../../../assets/Icons/Orange Filter.png";
import CrossIcon from "../../../assets/Icons/cross_svg.svg";
import { useForm, Controller } from "react-hook-form";
import { Box, CircularProgress } from "@mui/material";
import CustomAlert from "../../../helpers/CustomAlert";
import { axiosPostApi } from "../../../helpers/interceptorServices";
import { apiList } from "../../../helpers/apiList";

const statusOptions = [
  { value: "1", label: "Active" },
  { value: "4", label: "In-Active" },
  { value: "3", label: "Block" },
  { value: "5", label: "Rejected" },
];

const statusOptionsTwo = [
  { value: "1", label: "Active" },
  { value: "4", label: "In-Active" },
];

const FranchiseFilterModal = ({
  show,
  handleClose,
  walletTitle,
  auditData,
  setCustomerData,
  setPageDetails,
  setNoData,
  pageSize,
  currentPage,
  filterData,
  setFilterData,
  handleReset,
  text,
}) => {
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: filterData,
    mode: "onChange",
  });

  // Watch all form values to check if a filter has a value
  const watchedValues = watch();

  // Function to check if a tab has an active filter value
  const hasActiveFilter = (tabName) => {
    switch (tabName) {
      case "Franchise Id":
        return (
          filterData?.franchiseCode && filterData.franchiseCode.trim() !== ""
        );
      case "Franchise Name":
        return (
          filterData?.franchiseName && filterData.franchiseName.trim() !== ""
        );
      case "GST No.":
        return filterData?.gstNumber && filterData.gstNumber.trim() !== "";
      case "Status":
        return filterData?.status && filterData.status.length > 0;
      case "Created Date":
        return (
          (filterData?.fromDate && filterData.fromDate !== "") ||
          (filterData?.toDate && filterData.toDate !== "")
        );
      case "Franchise PAN No":
        return (
          filterData?.companyPanNumber &&
          filterData.companyPanNumber.trim() !== ""
        );
      case "Mobile No":
        return (
          filterData?.primaryContactMobile &&
          filterData.primaryContactMobile.trim() !== ""
        );
      case "Email":
        return filterData?.emailId && filterData.emailId.trim() !== "";
      default:
        return false;
    }
  };

  const loggedInUserName = sessionStorage.getItem("username");
  const userRole = sessionStorage.getItem("userRole");
  const isCust = userRole === "CUST";
  const dynamicStatus = text === "AddUser" ? statusOptionsTwo : statusOptions;

  const [selectedTab, setSelectedTab] = useState(
    isCust ? "Franchise Id" : "Franchise Name",
  );
  const [loading, setLoading] = useState(false);

  const handleTabChange = (e, tabName) => {
    e.preventDefault();
    setSelectedTab(tabName);
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const onSubmit = (data) => {
    // setFilterData(data);
    fetchFranchiseData(currentPage);
  };

  const fetchFranchiseData = async (currentPage) => {
    setLoading(true);
    try {
      const payload = {
        username: loggedInUserName,
        franchiseName: filterData?.franchiseName,
        franchiseCode: filterData?.franchiseCode,
        gstNumber: filterData?.gstNumber,
        companyPanNumber: filterData?.companyPanNumber,
        status: filterData.status || [],
        fromDate: formatDate(filterData.fromDate),
        toDate: formatDate(filterData.toDate),
        primaryContactMobile: filterData?.primaryContactMobile,
        emailId: filterData?.emailId,
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_FRANCHISE_MASTER}?&pageSize=${pageSize}&pageNo=${1}`,
        payload,
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        const modifiedData = modifyStructure(response?.data?.data);
        setCustomerData(modifiedData);
        setNoData(modifiedData?.length === 0);
        handleClose();
      } else {
        CustomAlert({
          title: "Failed",
          text:
            response?.data?.message ||
            "There was an issue processing the request.",
          icon: "error",
          confirmButtonText: "Retry",
        });

        setCustomerData([]);
        setNoData(true);
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    return (
      response &&
      response?.map((customer, index) => ({
        ...customer,
        id: index + 1,
        address: customer.addr1 + ", " + customer.addr2 + ", " + customer.addr3,
      }))
    );
  };

  const onReset = () => {
    reset({
      franchiseCode: "",
      franchiseName: "",
      gstNumber: "",
      status: [],
      fromDate: "",
      toDate: "",
      companyPanNumber: "",
      primaryContactMobile: "",
      emailId: "",
    });
    setFilterData({
      franchiseCode: "",
      franchiseName: "",
      gstNumber: "",
      status: [],
      fromDate: "",
      toDate: "",
      companyPanNumber: "",
      primaryContactMobile: "",
      emailId: "",
    });
    handleReset();
  };


  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "40vw",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "space-between",
                }}
              >
                <div className="flex items-center gap-2">
                  <img src={FilterIcon} alt="filter icon" className="w-6 h-6" />
                  <h5 className="modal-title main-title font-medium">
                    Filters
                  </h5>
                </div>
                <img
                  src={CrossIcon}
                  alt="filter icon"
                  className="w-[30px] h-[30px] cursor-pointer z-20"
                  onClick={handleClose}
                />
              </div>
              <Box component="form">
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div className="tab-container">
                    <ul className="tab-list">
                      {[
                        isCust ? "Franchise Id" : "Franchise Name",
                        "GST No.",
                        "Status",
                        "Created Date",
                        "Franchise PAN No",
                        "Mobile No",
                        "Email",
                      ].map((tab) => (
                        <div className="tab-wrapper" key={tab}>
                          <li
                            className={
                              selectedTab === tab
                                ? "tab-item selected"
                                : "tab-item"
                            }
                            style={
                              hasActiveFilter(tab) && selectedTab !== tab
                                ? {
                                    outline: "2px solid #FF6B35",
                                    outlineOffset: "2px",
                                  }
                                : {}
                            }
                          >
                            <button
                              className={`tab-button ${
                                selectedTab === tab ? "active" : ""
                              }`}
                              onClick={(e) => handleTabChange(e, tab)}
                            >
                              {tab}
                            </button>
                          </li>
                          {selectedTab === tab && (
                            <img
                              src={ButtonTriangle}
                              alt="tri"
                              className="tab-triangle"
                            />
                          )}
                        </div>
                      ))}
                    </ul>

                    <div className="tab-content">
                      {selectedTab === "Franchise Id" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <label className="dateLabel">Franchise ID</label>
                            <input
                              type="text"
                              placeholder="Enter Franchise ID"
                              className="dateInput"
                              value={filterData.franchiseCode}
                              maxLength={20}
                              pattern="[A-Za-z0-9]+"
                              onChange={(e) => {
                                const val = e.target.value;
                                const cleanedVal = val.replace(
                                  /[^a-zA-Z0-9]/g,
                                  "",
                                );
                                setFilterData((prev) => ({
                                  ...prev,
                                  franchiseCode: cleanedVal,
                                }));
                              }}
                            />
                          </div>
                        </div>
                      )}

                      {selectedTab === "Franchise Name" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <label className="dateLabel">Franchise Name</label>
                            <input
                              type="text"
                              placeholder="Type any part of the franchise name"
                              className="dateInput"
                              value={filterData.franchiseName || ""}
                              maxLength={100}
                              onChange={(e) => {
                                const franchiseName = e.target.value;
                                setFilterData((prev) => ({
                                  ...prev,
                                  franchiseCode: "",
                                  franchiseName,
                                }));
                                setValue("franchiseCode", "");
                                setValue("franchiseName", franchiseName);
                              }}
                            />
                            {errors.customerName ? (
                              <div className="error">{errors.customerName}</div>
                            ) : null}
                          </div>
                        </div>
                      )}

                      {selectedTab === "GST No." && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <Controller
                              name="gstNumber"
                              control={control}
                              rules={{
                                pattern: {
                                  value:
                                    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                                  message: "Invalid GST Number format",
                                },
                              }}
                              render={({ field }) => (
                                <>
                                  <label className="dateLabel">GST No.</label>
                                  <input
                                    {...field}
                                    type="text"
                                    placeholder="Enter GST No."
                                    className="dateInput"
                                    value={filterData.gstNumber}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      setFilterData((prev) => ({
                                        ...prev,
                                        gstNumber: val,
                                      }));
                                      field.onChange(val);
                                    }}
                                  />
                                  {errors.gstNumber && (
                                    <div className="error-text">
                                      {errors.gstNumber.message}
                                    </div>
                                  )}
                                </>
                              )}
                            />
                          </div>
                        </div>
                      )}

                      {selectedTab === "Status" && (
                        <div className="dateField">
                          <label className="dateLabel">Status</label>
                          <div
                            className="dateInputWrapper"
                            style={{
                              display: "flex",
                              gap: "1rem",
                              flexWrap: "wrap",
                              padding: "0.75rem",
                              backgroundColor: "#ffdab8",
                              border: "1px solid #ced4da",
                              borderRadius: "0.5rem",
                            }}
                          >
                            {dynamicStatus.map((status) => (
                              <label
                                key={status.value}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.5rem",
                                  padding: "0.5rem 0.75rem",
                                  borderRadius: "0.375rem",
                                  cursor: "pointer",
                                  fontSize: "0.9rem",
                                  fontWeight: "500",
                                  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                }}
                              >
                                {/* <input
                                  type="checkbox"
                                  checked={(filterData.status || []).includes(
                                    status.label
                                  )}
                                  onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    const newStatus = isChecked
                                      ? [
                                          ...(filterData.status || []),
                                          status.label,
                                        ]
                                      : (filterData.status || []).filter(
                                          (v) => v !== status.label
                                        );
                                    setValue("status", newStatus);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      status: newStatus,
                                    }));
                                  }}
                                  style={{ cursor: "pointer" }}
                                /> */}
                                <input
                                  type="checkbox"
                                  checked={(filterData.status || []).includes(
                                    status.value,
                                  )}
                                  onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    const newStatus = isChecked
                                      ? [
                                          ...(filterData.status || []),
                                          status.value,
                                        ]
                                      : (filterData.status || []).filter(
                                          (v) => v !== status.value,
                                        );

                                    setFilterData((prev) => ({
                                      ...prev,
                                      status: newStatus,
                                    }));
                                  }}
                                />
                                {status.label}
                              </label>
                            ))}
                          </div>
                        </div>
                      )}

                      {selectedTab === "Created Date" && (
                        <div
                          className="dateGrid"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "1rem",
                            alignItems: "flex-start",
                          }}
                        >
                          <Controller
                            name="fromDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid From Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "From Date cannot be in the future",
                                beforeToDate: (value, formValues) =>
                                  !value ||
                                  !formValues.toDate ||
                                  new Date(value) <=
                                    new Date(formValues.toDate) ||
                                  "From Date must be before To Date",
                                requiredIfToDate: (value, formValues) =>
                                  !formValues.toDate ||
                                  !!value ||
                                  "From Date is required when To Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">From Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        fromDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.fromDate && (
                                    <div className="error-text">
                                      {errors.fromDate.message}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                          <Controller
                            name="toDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid To Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "To Date cannot be in the future",
                                afterFromDate: (value, formValues) =>
                                  !value ||
                                  !formValues.fromDate ||
                                  new Date(value) >=
                                    new Date(formValues.fromDate) ||
                                  "To Date must be after From Date",
                                requiredIfFromDate: (value, formValues) =>
                                  !formValues.fromDate ||
                                  !!value ||
                                  "To Date is required when From Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">To Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        toDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.toDate && (
                                    <div className="error-text">
                                      {errors.toDate.message}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                        </div>
                      )}

                      {selectedTab === "Franchise PAN No" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <Controller
                              name="companyPanNumber"
                              control={control}
                              rules={{
                                pattern: {
                                  value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                                  message:
                                    "Invalid PAN Number format. (e.g., ABCDE1234F)",
                                },
                              }}
                              render={({ field }) => (
                                <>
                                  <label className="dateLabel">
                                    Franchise PAN No
                                  </label>
                                  <input
                                    {...field}
                                    type="text"
                                    placeholder="Enter Franchise PAN No"
                                    className="dateInput"
                                    value={filterData.companyPanNumber}
                                    onChange={(e) => {
                                      const val = e.target.value
                                        .toUpperCase()
                                        .replace(/[^A-Z0-9]/g, "");
                                      setFilterData((prev) => ({
                                        ...prev,
                                        companyPanNumber: val,
                                      }));
                                      field.onChange(val);
                                    }}
                                    maxLength={10}
                                  />
                                  {errors.companyPanNumber && (
                                    <div className="error-text">
                                      {errors.companyPanNumber.message}
                                    </div>
                                  )}
                                </>
                              )}
                            />
                          </div>
                        </div>
                      )}

                      {selectedTab === "Mobile No" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <Controller
                              name="primaryContactMobile"
                              control={control}
                              rules={{
                                // Partial numbers are allowed: the search matches any part of the number
                                pattern: {
                                  value: /^\d{0,10}$/,
                                  message: "Mobile No can contain only digits",
                                },
                              }}
                              render={({ field }) => (
                                <>
                                  <label className="dateLabel">Mobile No</label>
                                  <input
                                    {...field}
                                    type="text"
                                    placeholder="Type any part of the mobile no"
                                    className="dateInput"
                                    value={filterData.primaryContactMobile}
                                    onChange={(e) => {
                                      const val = e.target.value.replace(
                                        /[^0-9]/g,
                                        "",
                                      );
                                      setFilterData((prev) => ({
                                        ...prev,
                                        primaryContactMobile: val,
                                      }));
                                      field.onChange(val);
                                    }}
                                    maxLength={10}
                                  />
                                  {errors.primaryContactMobile && (
                                    <div className="error-text">
                                      {errors.primaryContactMobile.message}
                                    </div>
                                  )}
                                </>
                              )}
                            />
                          </div>
                        </div>
                      )}

                      {selectedTab === "Email" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <label className="dateLabel">Email</label>
                            <input
                              type="text"
                              placeholder="Type any part of the email"
                              className="dateInput"
                              value={filterData.emailId || ""}
                              maxLength={100}
                              onChange={(e) => {
                                const emailId = e.target.value.trim();
                                setFilterData((prev) => ({ ...prev, emailId }));
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <div className="buttonContainer">
                    <button
                      onClick={handleSubmit(onSubmit)}
                      className="btn btn-submit !rounded-lg w-[133px]"
                      disabled={loading}
                    >
                      {loading ? (
                        <CircularProgress
                          style={{ width: "20px", height: "20px" }}
                        />
                      ) : (
                        "Apply"
                      )}
                    </button>
                  </div>
                  <div className="buttonContainer">
                    <button
                      type="button"
                      className="btn btn-back !rounded-lg w-[133px]"
                      onClick={onReset}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FranchiseFilterModal;
